const INVALID_CHARACTERS_REGEX = /[^\d-,.]|(?:\.|,)(?!\d{1,2}[^\d-,.]*$)/g;
const REPLACE_COMMA_REGEX = /,(?=\d{1,2})/g;

export const CurrencyUtils = {
    unformatCurrency: (value: string): number | undefined => {
        value = value.replace(INVALID_CHARACTERS_REGEX, '').replace(REPLACE_COMMA_REGEX, '.');

        return value ? Number(value) : undefined;
    }
}

export default CurrencyUtils;